import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import * as actions from './store/actions';
import ValidatorTable from './validator-table/validator-table';
import ErrorsDialog from './errors-dialog/errors-dialog';
import ImportSummary from './import-summary/import-summary';
import ApiService from './services/service';

const mapStateToProps = state => {
  return {
    profiles: state.measurementValidator.profiles,
    canImport: state.measurementValidator.profiles.some(p => p.shouldImport)
  };
};

const mapDispatchToProps = {
  loadProfiles: profiles => actions.ProfilesLoaded(profiles),
  profileSelected: (profile, checked) => actions.ProfileSelected(profile, checked)
};

@connect(mapStateToProps, mapDispatchToProps)
class MeasurementValidator extends Component {
  static propTypes = {
    // from view
    importResult: PropTypes.object.isRequired,
    backUrl: PropTypes.string.isRequired,
    importUrl: PropTypes.string.isRequired,
    profilePreviewUrl: PropTypes.string.isRequired,
    // from redux
    loadProfiles: PropTypes.func,
    profileSelected: PropTypes.func,
    profiles: PropTypes.array,
    canImport: PropTypes.bool,
  }

  state = {
    detail: undefined,
    imported: undefined,
    isImporting: false,
  }

  componentDidMount = () => {
    const { importResult, loadProfiles } = this.props;
    loadProfiles(importResult.profiles);
  }

  shouldImportChanged = (profile, checked) => {
    this.props.profileSelected(profile, checked);
  }

  openErrors = (profile) => {
    this.setState({ detail: profile });
  }

  closeErrors = () => {
    this.setState({ detail: undefined });
  }

  render = () => {
    const { profiles, canImport, backUrl, profilePreviewUrl, importResult: { fileGuid } } = this.props;
    const validator = (
      <ValidatorTable
        fileGuid={fileGuid}
        profiles={profiles}
        shouldImportChanged={this.shouldImportChanged}
        openErrors={this.openErrors}
        confirmImport={this.confirmImport}
        backUrl={backUrl}
        profilePreviewUrl={profilePreviewUrl}
        canImport={canImport}
        isImporting={this.state.isImporting}>
      </ValidatorTable>);
    const errorDetails = (
      <ErrorsDialog
        onClose={this.closeErrors}
        profileOverview={this.state.detail}>
      </ErrorsDialog>);
    let component = this.state.detail ? errorDetails : validator;
    let page = this.state.imported ? <ImportSummary {...this.state.imported} backUrl={backUrl}></ImportSummary> : component;

    const classNames = ["MeasurementValidator"];
    if(this.state.isImporting){
      classNames.push('confirming-import');
    }

    return (
      <div className={classNames.join(' ')}>
        {page}
      </div>);
  }

  confirmImport = () => {
    const { importUrl, profiles } = this.props;
    const { fileGuid, fileName, projectId } = this.props.importResult;

    this.setState({isImporting: true});

    ApiService.confirmImport(
      projectId, profiles, fileGuid, fileName, importUrl, 
      result => this.setState({ imported: result, isImporting: false }));
  }
}

export default MeasurementValidator;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/measurement-validator.js